module.exports = {"link_actions":"Actions","back_to_list":"Back to list"}